import { SessionPayload } from "@/types/session";

export default function decodeSessionCookie(
  cookie?: string,
): SessionPayload | undefined {
  if (!cookie) {
    return;
  }

  try {
    return JSON.parse(decodeURIComponent(cookie)) as SessionPayload;
  } catch (e) {
    return undefined;
  }
}
